import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import {DownloadRounded, PercentRounded} from "@mui/icons-material";
import { Card, Table, Progress, Space, Typography } from 'antd';
import CSVFile from "../../../Components/CSVFile/CSVFile";
import TickerChip from "../../../Components/TickerChip";
import { useEnsureTickersLoaded } from "../../../hooks/useEnsureTickersLoaded";
import { stringMixin } from "../../../utils/strings";
import PnL from "../../../Components/PnL";

const { Title } = Typography;


const renderSecurity = (id, tickers) => {
  const tickerObject = tickers.find(x => x.symbol === id);
  return tickerObject ? <TickerChip ticker={tickerObject} /> : '';
};


const PortfolioSignalsTable = ({ dataSource, title='Current Portfolio', setShowExport,
                                 showExport=false, showDelta=true }) => {
  const { tickers, loading } = useEnsureTickersLoaded(dataSource.map(x => x.id));
  const totalWeight = useMemo(() => dataSource.reduce((acc, item) => acc + item.weight, 0), [dataSource]);
  const cashWeight = useMemo(() => 1 - totalWeight, [totalWeight]);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: 'Security',
        dataIndex: 'id',
        key: 'id',
        render: (id, record)=> renderSecurity(id, tickers),
      },
      {
        title: 'Weight',
        dataIndex: 'weight',
        key: 'weight',
        editable: true,
        render: (text, record) =>  (
            <Progress
              size={'small'}
              type={'circle'}
              percent={text * 100}
              format={(p) => `${p.toFixed(2)}%`}
            />
        )
      },
    ];
    if (showDelta) {
      baseColumns.push({
        title: "Delta",
        dataIndex: "delta",
        key: "delta",
        render: (text, record) => (
            <PnL value={record?.delta} />
        )
      })
    }
    return baseColumns;
  }, [tickers]);

  const Extra = useCallback(() => (
    <Space size={'large'}>
      <Chip
          icon={<PercentRounded/>}
          label={`in Cash ${stringMixin.pct(Math.abs(cashWeight))}`}
          color={cashWeight > 0.01 ? 'success' : 'error'}
          variant={'outlined'}
      />
    </Space>
  ), [cashWeight]);

  return (
    <Card
      bordered={false}
      extra={Extra()}
      title={title}
    >
      <CSVFile
        dataSource={dataSource}
        initialColumns={columns}
        visible={showExport}
        onClose={()=>setShowExport(false)}
      />
      <Table
        dataSource={dataSource}
        columns={columns}
        scroll={{y: 600}}
        pagination={false}
      />
    </Card>
  );
};

export default PortfolioSignalsTable;
